import React from 'react'

//eetilos
import './exportarPlanilla.css'

export const ExportExcel = ({ filters, initExport }) => {
    return (
        <button className='btn p-btn-light' onClick={() => initExport(filters)}>
            <i className="bi bi-file-earmark-excel"></i>
            <span style={{ marginLeft: '5px' }}>Exportar</span>
        </button>
    )
}
